'use client';

import React from 'react';
import { Heading } from '@ui';
import { Section, Container } from '@layout';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

interface TimelineStep {
  label: string;
  description: string;
}

const stepsEn: TimelineStep[] = [
  {
    label: 'Step 1',
    description: 'Start your project and set up the basics.',
  },
  {
    label: 'Step 2',
    description: 'Develop features and iterate quickly.',
  },
  {
    label: 'Step 3',
    description: 'Test, deploy, and monitor your app.',
  },
];

interface TimelineDemoProps {
  sectionID?: string;
  className?: string;
  isSpanish?: boolean;
}

const TimelineDemo: React.FC<TimelineDemoProps> = ({
  isSpanish = false,
  sectionID = 'timeline-demo',
  className = 'timeline-demo',
}) => {

  const steps: TimelineStep[] = isSpanish
    ? [
        { label: 'Paso 1', description: 'Inicia tu proyecto y configura lo básico.' },
        { label: 'Paso 2', description: 'Desarrolla funciones e itera rápidamente.' },
        { label: 'Paso 3', description: 'Prueba, implementa y monitorea tu aplicación.' },
      ]
    : stepsEn;

  return (
    <Section sectionID={sectionID} className={className}>
      <Container>
        <Heading as="h3">{isSpanish ? 'Ejemplo de línea de tiempo' : 'Timeline Sample'}</Heading>
        <p className='sub full'>
          {isSpanish
            ? 'Una línea de tiempo vertical usando las clases .timeline y .step para layouts secuenciales.'
            : 'A vertical timeline using the .timeline and .step classes for sequential layouts.'}
        </p>
        <div className='timeline'>
          {steps.map((step, idx) => (
            <div className='step' key={step.label}>
              <div className='dot'>{idx + 1}</div>
              <div className='body'>
                <div className='h3'>{step.label}</div>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
        <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<div class="timeline">
  <div class="step">
    <div class="dot">1</div>
    <div class="body">
      <div class="h3">Step</div>
      <p>What happened.</p>
    </div>
  </div>
</div>`}
        />
      </Container>
    </Section>
  );
};

export default TimelineDemo;
